export type SvipRefundStatus =
    | 'not_refunded'
    | 'no_refund'
    | 'processing'
    | 'succeeded'
    | 'success'
    | 'failed'
    | 'unknown'
    | 'entitlement_failed'

interface RefundStatusPresentation {
    text: string
    color?: string
}

const refundStatusMap: Record<SvipRefundStatus, RefundStatusPresentation> = {
    not_refunded: { text: '未退款' },
    no_refund: { text: '未退款' },
    processing: { text: '退款处理中', color: 'blue' },
    succeeded: { text: '退款已完成', color: 'green' },
    success: { text: '退款已完成', color: 'green' },
    failed: { text: '退款失败', color: 'red' },
    unknown: { text: '退款结果确认中', color: 'orange' },
    entitlement_failed: { text: '退款已完成，权益撤销异常', color: 'red' },
}

export const getSvipRefundStatusPresentation = (status?: string): RefundStatusPresentation =>
    refundStatusMap[status as SvipRefundStatus] || { text: '--' }

export const formatSvipExpireTime = (value?: string | null, formatter?: (date: string) => string) => {
    if (!value) return '--'

    return formatter ? formatter(value) : value
}
